module.exports = __webpack_public_path__ + "media/src/img/soh-logo-2f19b82f5b8476662963b607b74a2770.svg";